<template>
<a-spin :spinning="showLoading">
<a-layout id="components-layout-demo-side" :key="uiKey">
    <a-sidebar />
    <a-layout >
        <a-header />
        <div id="components-back-top">
            <a-back-top>
                <div class="ant-back-top-inner">
                    <a-icon type="arrow-up" />
                </div>
            </a-back-top>
        </div>
        <a-divider class="topdivider"></a-divider>
        <a-layout-content style="margin: 0 16px; min-height: 100vh;">
            <slot />
        </a-layout-content>
        <a-layout-footer style="text-align: center">D3 Metalab © 2020</a-layout-footer>
    </a-layout>
</a-layout>
</a-spin>
</template>

<script>
import ASidebar from "@/components/Layout/ASidebar.vue";
import AHeader from "@/components/Layout/AHeader.vue";

export default {
    components: {
        ASidebar,
        AHeader
    },
    computed: {
        showLoading() {
            return this.$store.state.ui.show_loading;
        },
        uiKey() {
            return this.$store.state.ui.ui_key;
        }
    },
};
</script>

<style scoped>
  #components-back-top-demo-custom .ant-back-top {
    bottom: 100px;
  }
  #components-back-top-demo-custom .ant-back-top-inner {
    height: 40px;
    width: 40px;
    line-height: 40px;
    border-radius: 4px;
    background-color: #1088e9;
    color: #fff;
    text-align: center;
    font-size: 20px;
  }
</style>